import { InlineMenu as InlineMenuCore } from "@/components/ui/editor/core/components/inline-menu";
import { useEditorContext } from "../rich-text-editor-provider";

export const InlineMenu = ({ className }: { className?: string }) => {
  const { editor, openInlineMenu } = useEditorContext("Editor");
  if (!editor) return null;
  return (
    <InlineMenuCore
      editor={editor}
      openInlineMenu={openInlineMenu}
      className={className}
    />
  );
};
